export default "__VITE_ASSET__CT0i269L__"